var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12956",
    "data-name": "Path 12956",
    d: "M123.953,250.069h-4.526a.618.618,0,0,1-.625-.61h0V233.13a.618.618,0,0,1,.625-.61h4.526a.617.617,0,0,1,.625.61h0v16.329a.618.618,0,0,1-.625.61Zm-20.148-.211,7.5-14.59a.6.6,0,0,0-.277-.82l-4.044-1.986a.631.631,0,0,0-.839.271l-7.5,14.59a.6.6,0,0,0,.277.82l4.044,1.986A.635.635,0,0,0,103.8,249.858Zm11.106-.058,3.21-15.9a.61.61,0,0,0-.49-.717l-4.438-.876a.627.627,0,0,0-.738.479v0l-3.21,15.9a.611.611,0,0,0,.49.717l4.438.876a.626.626,0,0,0,.738-.479v0Z",
    transform: "translate(-98.578 -232.292)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2510",
    "data-name": "Rectangle 2510",
    width: 29.162,
    height: 21.087,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Make",
    transform: "translate(-80 -177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(80 177)",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Make-Formerly-Integromat",
    transform: "translate(-11.578 -44.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    transform: "translate(98.578 232.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12954",
    "data-name": "Group 12954",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12953",
    "data-name": "Group 12953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12957",
    "data-name": "Path 12957",
    d: "M123.953,250.069h-4.526a.618.618,0,0,1-.625-.61h0V233.13a.618.618,0,0,1,.625-.61h4.526a.617.617,0,0,1,.625.61h0v16.329a.618.618,0,0,1-.625.61Zm-20.148-.211,7.5-14.59a.6.6,0,0,0-.277-.82l-4.044-1.986a.631.631,0,0,0-.839.271l-7.5,14.59a.6.6,0,0,0,.277.82l4.044,1.986A.635.635,0,0,0,103.8,249.858Zm11.106-.058,3.21-15.9a.61.61,0,0,0-.49-.717l-4.438-.876a.627.627,0,0,0-.738.479v0l-3.21,15.9a.611.611,0,0,0,.49.717l4.438.876a.626.626,0,0,0,.738-.479v0Z",
    transform: "translate(-98.578 -232.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6_8_",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5_8_",
    transform: "translate(-1.584 -1.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12952",
    "data-name": "Group 12952"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 29.162,
    height: 21.087,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3_8_",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12951",
    "data-name": "Group 12951"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2512",
    "data-name": "Rectangle 2512",
    width: 29.162,
    height: 21.087,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1_8_",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1_8_",
    width: 29.262,
    height: 21.333,
    transform: "translate(-0.089 -0.144)",
    fill: "#fff"
  }))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeGray);
export default __webpack_public_path__ + "static/media/Make-gray.edf621531f1f1416b6c0350d86a36827.svg";
export { ForwardRef as ReactComponent };